/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriveFileResource } from '../models/DriveFileResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CgvService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Conditions generales en vigueur d'une entreprise
     * Le dernier fichier de CGV depose, avec son `url` de telechargement. Renvoie `null` (200) s'il n'y en a pas.
     * @param companyId
     * @returns any `DriveFileResource`
     * @throws ApiError
     */
    public cgvShow(
        companyId: number,
    ): CancelablePromise<(DriveFileResource | null)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/company/{companyId}/cgv',
            path: {
                'companyId': companyId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Deposer les conditions generales d'une entreprise
     * PDF de 10 Mo maximum (`file`, multipart). Devient le document propose a l'acceptation lors des signatures de devis ; les versions precedentes sont conservees.
     * @param companyId
     * @param formData
     * @returns DriveFileResource `DriveFileResource`
     * @throws ApiError
     */
    public cgvStore(
        companyId: number,
        formData: {
            file: Blob;
        },
    ): CancelablePromise<DriveFileResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/company/{companyId}/cgv',
            path: {
                'companyId': companyId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un fichier de conditions generales
     * 204 sans contenu en cas de succes. 422 si le fichier n'est pas un document de CGV ; 409 s'il a deja ete accepte lors d'une signature (il doit alors etre conserve).
     * @param companyId
     * @param fileId
     * @returns void
     * @throws ApiError
     */
    public cgvDestroy(
        companyId: number,
        fileId: number,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/company/{companyId}/cgv/{fileId}',
            path: {
                'companyId': companyId,
                'fileId': fileId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
